import { Injectable, signal } from '@angular/core';

export type NotificationType = 'success' | 'warning' | 'error';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  state = signal({
    visible: false,
    type: '' as NotificationType,
    title: '',
    message: '',
  });

  private hideTimeout!: ReturnType<typeof setTimeout>;

  private show(type: NotificationType, title: string, message: string) {
    clearTimeout(this.hideTimeout);

    this.state.set({
      visible: true,
      type,
      title,
      message,
    });

    this.hideTimeout = setTimeout(() => {
      this.state.set({
        visible: false,
        type: '' as NotificationType,
        title: '',
        message: '',
      });
    }, 3000);
  }

  success(message: string) {
    this.show('success', '¡Acción realizada correctamente!', message);
  }

  warning(message: string) {
    this.show('warning', 'Atención requerida', message);
  }

  error(message: string) {
    this.show('error', 'Error', message);
  }
}
